export default {
      id: "search-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }